import React, { useCallback } from 'react';
import { Col, Row } from 'antd';
import styled from 'styled-components';
import Link from 'next/link';
import Image from 'components/Image';
import VoteButton from './VoteButton';

const ArticleTitle = styled.h3`
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.41;
    letter-spacing: normal;
    text-align: left;
    color: inherit;
`;

const ArticleCard = styled(Row)`
    :hover {
        a {
            color: red;
        }
    }
    a {
        color: ${(props) => props.color || props.theme.colors.derkerGrey};
    }
`;

type CategoryArticle = Pick<Article, 'seoSlug' | 'title' | 'openingImage' | 'teaser'>;

type Props = {
    article: CategoryArticle;
    isVoted: boolean;
    handleVote: (articleSlug: string) => void;
};

export const Text = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    font-weight: 300;
    word-wrap: break-word;
    -webkit-line-clamp: 4; /* number of lines to show */
    -webkit-box-orient: vertical;
    @media (max-width: 768px) {
        display: none;
    }
`;

export const ImageStyled = styled(Image)`
    border-color: ${(props) => props.color || props.theme.colors.primary};
    border-width: 1px;
    border-style: solid;
    margin: 0 auto;
`;

export const Item = ({ article, isVoted, handleVote }: Props) => {
    const onVote = useCallback(() => {
        handleVote(article.seoSlug);
    }, [article, handleVote]);

    return (
        <ArticleCard gutter={16}>
            <Col span={24} style={{ margin: '0 auto' }}>
                <Link href={`/artykuly/${article.seoSlug}`} target="_blank">
                    <ImageStyled
                        type="index"
                        height={178}
                        width={316}
                        alt={article.title}
                        src={article.openingImage}
                    />
                </Link>
            </Col>
            <Col span={24}>
                <Link href={`/artykuly/${article.seoSlug}`} target="_blank">
                    <ArticleTitle>{article.title}</ArticleTitle>
                </Link>
                <Text>
                    <Link href={`/artykuly/${article.seoSlug}`} target="_blank">
                        <div dangerouslySetInnerHTML={{ __html: article.teaser }} />
                    </Link>
                </Text>
            </Col>
            <Col span={24} style={{ paddingTop: 10, textAlign: 'right' }}>
                <VoteButton isVoted={isVoted} onVote={onVote} />
            </Col>
        </ArticleCard>
    );
};

export default Item;
